import { carouselData } from "@/mocks/homeData";

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">📰 焦点专题</h2>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">深度策划专题内容，全面梳理重大吃瓜事件始末</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselData.map((item, i) => (
            <article
              key={i}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all hover:shadow-lg ${
                i === 0 ? "lg:col-span-3" : "lg:col-span-2"
              }`}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${item.color} opacity-90`}></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <img
                src={item.image}
                alt={item.title}
                className={`w-full object-cover ${i === 0 ? "aspect-[16/9] md:aspect-[21/9]" : "aspect-[4/3] md:aspect-[3/4]"}`}
                loading="lazy"
              />
              <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
                <span className="self-start px-2.5 py-1 bg-white/20 backdrop-blur-sm text-background-50 text-xs font-semibold rounded-md mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className={`font-bold text-background-50 leading-tight mb-2 font-heading ${
                  i === 0 ? "text-base md:text-xl" : "text-sm md:text-base"
                }`}>
                  {item.title}
                </h3>
                <p className={`text-background-50/80 leading-relaxed line-clamp-2 ${
                  i === 0 ? "text-xs md:text-sm" : "text-xs"
                }`}>
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}